<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="loco-status-tbl-head">
  <div class="lsc-loco-icon"> &nbsp; </div>
  <div class="lsc-loco-id">{{configData && configData.locoStatusLabel.locomotiveId}}</div>
  <div class="lsc-current-assgnmt">{{configData && configData.locoStatusLabel.currentAssignment}}</div>
  <div class="lsc-frr">{{configData && configData.locoStatusLabel.foreignRoad}}</div>
  <div class="lsc-tag">{{configData && configData.locoStatusLabel.tag}}</div>
  <div class="lsc-class">{{configData && configData.locoStatusLabel.class}}</div>
  <div class="lsc-last-rpt">{{configData && configData.locoStatusLabel.lastReporting}}</div>
  <div class="lsc-city-state">{{configData && configData.locoStatusLabel.cityState}}</div>
</div>

<ul class="loco-status-tbl-data">
  <li class="clearfix" *ngFor="let locoStatus of locoStatusDataArr; let i = index;">
    <lms-loco-status-container-data-row (updateDataStoreEvent)='updateDataStoreEvent();' (doubleEnterEvent)='doubleEnterEvent();'
      (singleEnterEvent)='singleEnterEvent();' [locoStatus]='locoStatus' (locoSelectionEvent)='locoSelectionEvent();' [index]='i'
      [locoStatusDataArr]='locoStatusDataArr' [totalRow]='locoStatusDataArr.length' (onLocoSelect)='showLocoContextMenu($event);'
      (searchClickEvent)="searchClickEvent($event)" (removeLocoEvent)="removeLocoEvent($event)"></lms-loco-status-container-data-row>
    <span class="icon-close-row fa fa-times" title="Delete Row" (click)="removeLocoStatusRow(i);"></span>
  </li>
  <li class="generic-spacing" *ngIf="locoStatusDataArr && locoStatusDataArr.length === 0">{{configData && configData.messages.noRecordFound}}</li>
</ul>